import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

class ProtectedComponent extends Component {
  hasRole() {
    const { role, config } = this.props;

    const { isIntegradoKeyCloak, roles, isOnpremise, possuiAcesso } =
      config || {};

    if (!role) {
      return true;
    }

    if (isIntegradoKeyCloak && isOnpremise) {
      return possuiAcesso;
    }

    if (isIntegradoKeyCloak && !isOnpremise) {
      return !!roles?.some(r => r.name === role);
    }

    return true;
  }

  render() {
    return this.hasRole() && <>{this.props.children}</>;
  }
}

function mapStateToProps(state) {
  return {
    config: state.config
  };
}

export default connect(mapStateToProps)(ProtectedComponent);
